import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectIsAuthenticated } from '../../../store/reducers';

export function NavigationBar(): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const paths = location.pathname.split('/');
  const isAuthenticated = useSelector(selectIsAuthenticated);
  if (!isAuthenticated) {
    return <></>;
  }

  const handleNavigate = (e: React.MouseEvent<HTMLElement, MouseEvent>, navigateTo: string): void => {
    e.preventDefault();
    navigate(navigateTo, { replace: true });
  };

  return (
    <>
      <Navbar expand='lg' className='bg-body-tertiary' data-bs-theme='dark' fixed='top'>
        <Container>
          <Navbar.Toggle aria-controls='basic-navbar' />
          <Navbar.Collapse id='basic-navbar'>
            <Nav className='me-auto'>
              <Nav.Link
                active={paths[1] === 'dashboard'}
                href='/dashboard'
                onClick={(e) => handleNavigate(e, '/dashboard')}
              >
                Dashboard
              </Nav.Link>
              <Nav.Link
                active={paths[1] === 'abteilung'}
                href='/abteilung'
                onClick={(e) => handleNavigate(e, '/abteilung')}
              >
                Abteilung
              </Nav.Link>
              <Nav.Link
                active={paths[1] === 'mitglieder'}
                href='/mitglieder'
                onClick={(e) => handleNavigate(e, '/mitglieder')}
              >
                Mitglieder
              </Nav.Link>
              <Nav.Link
                active={paths[1] === 'kleidung'}
                href='/mitglieder'
                onClick={(e) => handleNavigate(e, '/kleidung')}
              >
                Kleidung
              </Nav.Link>
              <Nav.Link
                active={paths[1] === 'waschzyklus'}
                href='/waschzyklus'
                onClick={(e) => handleNavigate(e, '/waschzyklus')}
              >
                Waschzyklus
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
